import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.moonSign;

const getMoonSign = createSelector(getData, moonSign => values(moonSign));

export default getMoonSign;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getMoonSign.js